<div class="flex justify-center items-center w-full" *ngIf="loading">
    <mat-spinner></mat-spinner>
</div>

<div class="grid grid-cols-1 gap-y-2" *ngIf="!loading">
    <h3 class="text-center md:text-left mb-2"><b>Please enter the voucher number and your mobile number</b></h3>
    <form [formGroup]="applicationDetailsForm">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-x-4">
            <mat-form-field appearance="standard" class="w-full tile" appearance="none">
                <mat-label><strong>Voucher Number</strong></mat-label>
                <input matInput placeholder="00000000000000" [formControl]="voucherNumber" required>
                <mat-error *ngIf="voucherNumber.hasError('required')">Voucher number is required</mat-error>
                <mat-error *ngIf="voucherNumber.hasError('validationFailed')">{{validationErrorMessage}}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="standard" class="w-full tile" appearance="none">
                <mat-label><strong>Mobile Number</strong></mat-label>
                <input matInput placeholder="082 000 0000" [formControl]="mobileNumber" required>
                <mat-error *ngIf="mobileNumber.hasError('required')">Mobile number is required</mat-error>
            </mat-form-field>
        </div>
    </form>
    <button class="pay py-3 mt-4 w-full min-w-max md:px-12 text-lg font-semibold tracking-widest continue justify-self-center md:justify-self-end" [ngStyle]="{'background-color':getColorScheme(), 'color':getTextColor()}" mat-raised-button (click)="initiateVoucherTransaction()">Pay Now</button>
</div>
